
import { ucWords } from '@/services/inputTools';

export interface SecurityLevel {
    level: string;
    name: string;
}

export const SecurityLevels: SecurityLevel[] = ['GENERAL_OFFICE', 'DIRECTOR', 'FIELD_COORDINATOR', 'INSTRUCTOR']
    .map((key) => {
        return {
            level: key,
            name: ucWords(key)
        } as SecurityLevel;
    }) ;

export default SecurityLevels;
